
import Vue from 'vue'

export default Vue.extend({
  name: 'CompareSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
